// Canonical Tarru brand mark — the official "T" monogram + leaf
// (Tarru Roots_01-08, the designer's vector). Two-tone: deep olive
// "T" (#475827) + lime leaf (#939e39).
//
// The export name stays "BrandLeaf" for backward compat (22+ imports
// across customer/admin/b2b/supplier). The web/ marketing site has its
// own TarruLogo component with the identical artwork. The standalone
// /tarru-tree.svg favicon mirrors this exact geometry.
//
// viewBox is cropped to the artwork ("55 55 140 140") so the mark fills
// its box at any `size` instead of floating in the designer's padding.

const TARRU_GREEN = '#475827'
const TARRU_LEAF  = '#939e39'

export function BrandLeaf({
  size = 30,
  className,
  color,
  'aria-label': ariaLabel,
}: {
  size?: number
  className?: string
  /** Render in a single colour (e.g. white on a dark/photo background). */
  color?: string
  'aria-label'?: string
}) {
  const role      = ariaLabel ? 'img' : undefined
  const tColor    = color ?? TARRU_GREEN
  const leafColor = color ?? TARRU_LEAF

  return (
    <svg
      width={size}
      height={size}
      viewBox="55 55 140 140"
      fill="none"
      role={role}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
      className={className}
    >
      <path
        fill={tColor}
        d="m167.2,96.6h-24.84v73.98h-18.23v-73.98h-29.99c-8.19,0-14.4,6.07-14.4,14s6.21,14,14.4,14v17.17c-18.36,0-32.1-13.34-32.1-31.17s13.74-31.18,32.1-31.18h73.05v17.17Z"
      />
      <path
        fill={leafColor}
        d="m178.55,101.83h9.4v9.4c0,15.17-12.31,27.48-27.48,27.48h-9.4v-9.4c0-15.17,12.31-27.48,27.48-27.48Z"
        transform="translate(339.02 240.55) rotate(180)"
      />
    </svg>
  )
}
